<template>
    <div class="tw-h-full tw-flex tw-flex-col tw-space-y-3">
        <!-- Progress Indicator -->
        <div class="tw-flex-shrink-0">
            <div class="tw-flex tw-items-center tw-justify-between tw-text-sm tw-text-gray-600 tw-mb-2">
                <span>{{ $t('onboarding.progress.step_of', { current: 2, total: 4 }) }}</span>
                <span class="tw-hidden sm:tw-block">{{ $t('onboarding.progress.basic_info') }}</span>
                <span class="tw-block sm:tw-hidden">{{ $t('onboarding.progress.basic_info') }}</span>
            </div>
            <div class="tw-w-full tw-bg-gray-200 tw-rounded-full tw-h-2">
                <div class="tw-bg-primary-600 tw-h-2 tw-rounded-full tw-transition-all tw-duration-300" style="width: 50%"></div>
            </div>
        </div>

        <!-- Scrollable Content -->
        <div class="tw-flex-1 tw-overflow-y-auto tw-space-y-3">
            <!-- Welcome Message -->
            <div class="tw-bg-primary-50 tw-border tw-border-primary-200 tw-rounded-lg tw-p-2.5">
                <div class="tw-flex tw-items-start tw-gap-2.5">
                    <icon icon="solar:user-speak-bold-duotone" class="tw-text-primary-600 tw-text-base tw-mt-0.5 tw-flex-shrink-0" />
                    <div>
                        <h3 class="tw-text-sm tw-font-medium tw-text-primary-800 tw-mb-0.5">
                            {{ $t('onboarding.basic_info.title') }}
                        </h3>
                        <p class="tw-text-xs tw-text-primary-700 tw-leading-tight">
                            {{ $t('onboarding.basic_info.description') }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Full Name -->
            <FormField
                v-model="formData.full_name"
                type="text"
                :label="$t('onboarding.basic_info.full_name')"
                :placeholder="$t('onboarding.basic_info.full_name_placeholder')"
                left-icon="solar:user-bold-duotone"
                required
                :error="errors.full_name"
                :hide-errors="!errors.full_name"
            />

            <!-- Contact Email -->
            <FormField
                v-model="formData.contact_email"
                type="email"
                :label="$t('onboarding.basic_info.contact_email')"
                :placeholder="$t('onboarding.basic_info.contact_email_placeholder')"
                left-icon="solar:letter-bold-duotone"
                required
                :error="errors.contact_email"
                :hide-errors="!errors.contact_email"
            />

            <!-- Profile Image Upload -->
            <FormFileUpload
                v-model="formData.profile_image"
                :label="$t('onboarding.basic_info.profile_image')"
                :placeholder="$t('onboarding.basic_info.profile_image_placeholder')"
                :help="$t('onboarding.basic_info.profile_image_help')"
                left-icon="solar:gallery-bold-duotone"
                accept="image/*"
                :error="errors.profile_image"
                :hide-errors="!errors.profile_image"
            />
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import FormField from '@/components/form/FormField.vue';
import FormFileUpload from '@/components/form/FormFileUpload.vue';

const props = defineProps({
    formData: {
        type: Object,
        required: true
    },
    errors: {
        type: Object,
        default: () => ({})
    }
});

const emit = defineEmits(['update:formData']);

// Computed form data with two-way binding
const formData = computed({
    get: () => props.formData,
    set: (value) => emit('update:formData', value)
});
</script>

<style scoped>
/* Add any specific styles if needed */
</style> 